function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.8444 9.41325C13.638 9.41325 13.4708 9.58133 13.4708 9.78872V13.1224C13.47 13.7443 12.9688 14.2482 12.35 14.2488H1.86788C1.24915 14.2482 0.747882 13.7443 0.747152 13.1224V3.33825C0.747882 2.71654 1.24915 2.21259 1.86788 2.21186H5.18483C5.39117 2.21186 5.5584 2.04378 5.5584 1.8364C5.5584 1.62916 5.39117 1.46094 5.18483 1.46094H1.86788C0.836752 1.46211 0.00116743 2.30191 0 3.33825V13.1226C0.00116743 14.1589 0.836752 14.9987 1.86788 14.9999H12.35C13.3812 14.9987 14.2168 14.1589 14.2179 13.1226V9.78872C14.2179 9.58133 14.0507 9.41325 13.8444 9.41325Z",
  fill: "#FFFFFF"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.0712 0.494884C13.4147 -0.164961 12.3503 -0.164961 11.6938 0.494884L5.02892 7.19336C4.98325 7.23927 4.95027 7.29617 4.93305 7.35865L4.0566 10.5388C4.02056 10.6692 4.05718 10.8088 4.15233 10.9046C4.24762 11.0002 4.38655 11.037 4.51628 11.0009L7.68044 10.1199C7.74261 10.1026 7.79923 10.0695 7.8449 10.0236L14.5096 3.32493C15.1651 2.66464 15.1651 1.59575 14.5096 0.935465L14.0712 0.494884ZM5.84291 7.43741L11.2976 1.95508L13.0567 3.72312L7.60193 9.20546L5.84291 7.43741ZM5.49152 8.1461L6.89695 9.55877L4.95289 10.1001L5.49152 8.1461ZM13.9813 2.794L13.5851 3.1922L11.8258 1.42401L12.2222 1.02581C12.5869 0.659295 13.1782 0.659295 13.5428 1.02581L13.9813 1.46639C14.3454 1.83335 14.3454 2.42719 13.9813 2.794Z",
  fill: "#FFFFFF"
});

var SvgEdit = function SvgEdit(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit.efabc473.svg";
export { ForwardRef as ReactComponent };